import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-lesson-not-started',
    templateUrl: './lesson-not-started.component.html',
    styleUrls: ['./lesson-not-started.component.scss']
})
export class LessonNotStartedComponent implements OnInit, OnDestroy {
    studentName: string;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private route: ActivatedRoute, private location: Location) {}

    ngOnInit() {
        this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
            this.studentName = params['pupil_name'];
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    backHistory(): void {
        this.location.back();
    }
}
